import React from "react";
import { isEmpty } from "lodash";
import { OverlayTrigger, Tooltip, Row, Col } from "react-bootstrap";
import { GetInitials, EditActionSlider } from "../../../components";
import {
  getCommaSeparatedValuesFromArr,
  getFormattedSsn,
  getNullTableItem,
  ssnMasking,
} from "../../../utils";
import AddToolTip from "../../../components/AddToolTip";
// import employeeImage from "../../../assets/sample_image.png";

import { EmployeeStatus } from "../../../layouts";
import { useRequest } from "../../../abstracts";
import { getEmployeeImage, getCompanyLogo } from "../../../services";

const CustodianCard = ({
  custodianName,
  associatedPlans,
  custodianCode,
  logo,
}) => {
  return (
    <div className="custodian-card-item">
      <div
        className="custodian-card-item-content"
        style={{ height: "fit-content" }}
      >
        <div className="custodian-icon-wrapper d-flex justify-content-center">
          {!isEmpty(logo) ? (
            <img
              alt=""
              src={logo}
              style={{ width: "96px", height: "96px", borderRadius: "50%" }}
              className="img-fluid"
            />
          ) : (
            <div style={{ margin: "10%" }}>
              <GetInitials name={custodianName} />
            </div>
          )}
        </div>
        <div className="d-flex">
          <div className="d-flex flex-column plan-details-wrapper custodian-card-tile-text px-2">
            <Row>
              <Col>
                <div
                  className="ft-14 font-weight-500 custodian-name"
                  style={{
                    width: "150px",
                    height: "20px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    marginBottom: "8px",
                  }}
                >
                  {custodianName}
                </div>
                <div
                  className="ft-14 font-weight-500 marg-bot-4"
                  style={{
                    width: "150px",
                    height: "20px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {custodianCode}
                </div>
              </Col>
            </Row>
            <div className="card-line-separator"></div>

            <Row>
              <Col>
                <div className="d-flex ft-12" style={{ marginBottom: "8px" }}>
                  {associatedPlans} Associated Plan
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustodianCard;
